export default "/_next/static/images/rewardbg-d66c22249436adc0a59048d5480d54f2.png";